import { createAsyncThunk } from '@reduxjs/toolkit'
import { CategorySevice } from '../../api/CategoriesService'
import { IApi } from '../../interfaces/Api'
import { ICategory } from '../../interfaces/Category'

export const getCategories = createAsyncThunk('categories/get', async(id: string) => {
    const api = new CategorySevice()
    const _cats = await api.getCategories(id) 
    return [_cats as IApi<ICategory>, id]
})